import Api from '@/common/api';
import {
  SeatResponse,
  LockSeatRequest,
  SrcSysType,
  SrcWayType,
  SelectedSeat
} from '@/api/modules/seat/interface';
import { checkUnifyShop } from '@/utils';

function usePostLockSeats() {
  const requstLockSeats = function(
    dataSource: SeatResponse,
    selSeats: SelectedSeat[],
    sessionInfo: any,
    unionConfig: any,
    user: any,
    mobile: string,
    shadow: any,
  ) {
    const getParamSeat = () => {
      let arr: any = [];
      // dataSource.sectionPrices.length > 1;
      const isMul = dataSource.sectionPrices.length >1;
      selSeats.forEach((item: any) => {
        // 这里要区分单票价和多票价
        const originItem = dataSource.seats?.find((seat) => seat.vendorSeatId === item.vendorSeatId);

        const section = isMul && dataSource.sectionPrices && dataSource.sectionPrices.length
          ? dataSource.sectionPrices.find((sect) => sect.id === item.sectionId)
          : dataSource.sectionPrices[0] ;
        let s = {
          sectionId: item.sectionId,
          vendorSeatId: item.vendorSeatId,
          price: item.price,
          settlePrice: section?.settlePrice,
          dfCostPrice: section?.dfCostPrice,
          // desc: item.info,
          seatDesc: item.seatDesc,
          seatEnDesc: item.seatEnDesc,
          floorId: item.floorId,
          vendorSeatDesc:item.vendorSeatDesc,
          vendorOriginDesc:item.vendorOriginDesc,
          hallFee: section?.hallFee,
          serviceFee: section?.serviceFee,
          marketingCode: section?.marketingCode,
          seatX: originItem?.seatX,
          seatY: originItem?.seatY,
          seatType: originItem?.seatType,
          vendorSeatX: originItem?.vendorSeatX,
          vendorSeatY: originItem?.vendorSeatY
        };
        arr.push(s);
      });
      return arr;
    };
    const {
      cinemaId = '',
      cinemaName = '',
      dimensional = '',
      hallName = '',
      hallEnName = '',
      language = '',
      enLanguage = '',
      movieId = '',
      movieName = '',
      showDateTime = '',
      duration = '',
      dfScheduleId='',
      lowPriceTag = false,
      isVendor2Single,
      btnType
    } = dataSource?.newSessionInfo;
    const _win: any = window;
    const isZX =  _win.location.host.split('.')[0].indexOf('-zx') >= 0;
    const param: LockSeatRequest = {
      // cityId,
      districtId: '', // 没有
      cinemaId: cinemaId,
      movieId: movieId,
      cinemaName: cinemaName,
      movieName: movieName,
      hallName: hallName,
      hallEnName: hallEnName || dataSource.hallEnName,
      showStartTime: showDateTime, // 放映开始时间，格式yyyy
      duration: duration,
      dfScheduleId: dfScheduleId,
      vendor: dataSource.vendor,
      vendorSessionId: dataSource.vendorSessionId,
      floors: dataSource.floors,
      vendorCinemaId: dataSource.vendorCinemaId,
      movieCode: dataSource.movieCode,
      cinemaCode: dataSource.cinemaCode,
      vendorSessionCode: dataSource.vendorSessionCode,
      vendorHallCode: dataSource.vendorHallCode,
      //先加一个正选类型给测试，这个字段后端统一取网关
      //@ts-ignore
      srcSys: isZX ? 6 : ((unionConfig && !checkUnifyShop()) ? SrcSysType.BFD : SrcSysType.WWW), // 1-www 2-020 3-400 4-百福德
      srcWay: SrcWayType.H5, //1-PC 2-小程序 3-H5
      language: language,
      enLanguage: enLanguage || dataSource.enLanguage,
      dimensional: dimensional,
      sessionLastUpdateTime: dataSource.lastUpdateTime,
      vistaSource: dataSource.vistaSource,
      priceCode: dataSource.priceCode,
      priceName: dataSource.priceName,
      seats: getParamSeat(),
      // idNo: user.cardNumber, // 证件号
      // idType: user.activeId, // 证件类型 1-身份证 2-护照 3-台胞证 4-港澳台通行证
      // userName: user.name, // 用户名
      // userMobile: user.mobile, // 用户手机号,
      ticketMobile: mobile,
      sessionKey: dataSource.sessionKey,
      refVendor: dataSource.refVendor,
      refPrice: dataSource.refPrice,
      isSuperVipUser: dataSource.isSuperVipUser,
      optimumSelectStrategy: dataSource.optimumSelectStrategy,
      paySuccessUrl: `${window.location.protocol}//${window.location.host}`, //
      name: dataSource.name,
      lowPriceTag: lowPriceTag,
      isVendor2Single: isVendor2Single,
      buyScenario: isVendor2Single ? 1 : btnType,
      container: _win && _win?.DF_checkInLfMini() ? 1 : 0,
      shadow: shadow
    };
    // 锁座
    return Api.getLockSeat(param);
  };

  return {
    requstLockSeats
  };
}
export default usePostLockSeats;

// const param = {
//   // cityId,
//   districtId:'', // 没有
//   cinemaId:cinemaId,
//   movieId,
//   cinemaName,
//   movieName,
//   hallName,
//   showStartTime:showDateTime, // 放映开始时间，格式yyyy
//   duration: duration,
//   vendor: dataSource.vendor,
//   vendorSessionId: dataSource.vendorSessionId,
//   vendorCinemaId:dataSource.vendorCinemaId,
//   movieCode:dataSource.movieCode,
//   cinemaCode:dataSource.cinemaCode,
//   vendorSessionCode:dataSource.vendorSessionCode,
//   vendorHallCode:dataSource.vendorHallCode,
//   srcSys: union?'4':'1', // 1-www 2-020 3-400 4-百福德
//   srcWay:'3', //1-PC 2-小程序 3-H5
//   language,
//   dimensional,
//   lastUpdateTime:'',
//   vistaSource: dataSource.vistaSource,
//   priceCode:dataSource.priceCode,
//   priceName:dataSource.priceName,
//   sessionLastUpdateTime:dataSource.lastUpdateTime,
//   seats: getParamSeat(),
//   idNo: c_user.cardNumber, // 证件号
//   idType:c_user.activeId, // 证件类型 1-身份证 2-护照 3-台胞证 4-港澳台通行证
//   userName: c_user.name, // 用户名
//   userMobile: c_user.mobile, // 用户手机号
//   sessionKey: dataSource.sessionKey,
//   refVendor: dataSource.refVendor,
//   refPrice: dataSource.refPrice,
//   optimumSelectStrategy: dataSource.optimumSelectStrategy,
//   ticketMobile:mobile, // 取票手机号
//   paySuccessUrl: `${window.location.protocol}//${window.location.host}`
// };
// // 锁座
// Api.getLockSeat(param).then((res) => {
//   Toast.hide();
//   if(res.Status !== 0){
//     // error
//     setTimeoutModal(true);
//     // timeoutModal
//   }else{
//     toComfirmOrder(res.Data);
//   }

// });
